import { __ } from "@wordpress/i18n";
import { X } from "lucide-react";

export default function Errors({ errors }) {
    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded mb-5">
            <div className="flex items-start">
                <X className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0 text-red-500" />
                <div>
                    <p className="font-medium">
                        {__(
                            "Please fix the following errors:",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </p>
                    <ul className="list-disc list-inside mt-2">
                        {errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
